import { AppDefinition } from '../../types/apps';
import { FilePdf, FileText } from '@phosphor-icons/react';

// These events should match the APP_ACTIONS registry
export const PDF_EVENTS = {
  OPEN: 'PDF_OPEN',
  ZOOM_IN: 'PDF_ZOOM_IN',
  ZOOM_OUT: 'PDF_ZOOM_OUT',
  RESET_ZOOM: 'PDF_RESET_ZOOM',
  SELECT_TEXT: 'PDF_SELECT_TEXT',
  CLEAR_SELECTION: 'PDF_CLEAR_SELECTION',
  EXTRACT_TEXT: 'PDF_EXTRACT_TEXT',
} as const;

export const PDFiumAppDefinition: AppDefinition = {
  appId: 'pdfium', // KEY FIELD .... gets consumed in the front-end
  name: 'PDF Viewer & Editor',
  version: '2.0.0',
  description: 'View, edit, and design PDF files with a Figma-like canvas and AI assistance.',
  agenticToolIds: ['pdf_write'],
  
  // App icon
  icon: {
    type: 'phosphor',
    phosphorIcon: 'FilePdf',
    phosphorWeight: 'duotone',
    color: '#dc2626',
    metadata: {
      source: 'app',
      appId: 'pdfium',
      isAppIcon: true
    }
  },
  
  // Entity icons managed by this app
  entityIcons: {
    // Legacy types
    'PDF': {
      type: 'component',
      component: FilePdf,
      componentProps: {
        weight: 'fill',
        color: '#e74c3c',
      }
    },
    // Removed generic 'File' mapping - PDFium should only handle PDF-specific entities
    // Generic files should be handled by FileTypeService for proper hierarchical resolution
    'Document': {
      type: 'component',
      component: FileText,
      componentProps: {
        weight: 'regular',
      }
    },
    // Hierarchical types
    'File.Document.PDF': {
      type: 'component',
      component: FilePdf,
      componentProps: {
        weight: 'fill',
        color: '#e74c3c',
      }
    },
    'File.Document': {
      type: 'component',
      component: FileText,
      componentProps: {
        weight: 'regular',
      }
    }
  },
  
  // File type icons for extensions this app handles
  fileTypeIcons: {
    '.pdf': {
      type: 'component',
      component: FilePdf,
      componentProps: {
        weight: 'fill',
        color: '#e74c3c',
      }
    }
  },
  
  supportedFileTypes: ['.pdf'],
  events: PDF_EVENTS,
  // Support both legacy and hierarchical entity types
  entityTypes: ['PDF', 'File', 'File.Document.PDF', 'File.Document'],
  component: 'PDFiumApp',
  requiresProps: false,
  requiresEntity: false,
  isCore: true, // Allow launching without entity to show home screen
  experimental: true,
};
